import { Component, ReactNode } from 'react'
import { logSystemError } from '@/lib/systemLogger'

interface Props {
  children: ReactNode
}
interface State {
  hasError: boolean
  error: Error | null
}

export default class AppErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: { componentStack?: string }) {
    // Persiste o erro na tabela de observabilidade — critical pois derrubou o app inteiro
    void logSystemError(error, {
      module: 'AppErrorBoundary',
      action: 'render',
      severity: 'critical',
      requestPayload: { componentStack: info?.componentStack ?? null },
    })

    // Remove o splash inicial caso ainda esteja na tela
    document.getElementById('initial-loader')?.remove()
  }

  handleReload = () => {
    try {
      if ('caches' in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)))
      }
    } catch { /* storage indisponível — ignorado */ }
    window.location.reload()
  }

  render() {
    if (!this.state.hasError) return this.props.children
    const msg = this.state.error?.message || 'Erro desconhecido'
    const isChunkError = /chunk|loading.*failed|dynamically imported/i.test(msg)
    return (
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: '#070B1A',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
          zIndex: 99999,
        }}
      >
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <img src="/construzilla-logo.png?v=6" alt="Construzilla" style={{ maxWidth: 96, marginBottom: 12 }} />
          <h2 style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>
            Constru<span style={{ color: '#F59E0B' }}>zilla</span>
          </h2>
          <p style={{ fontSize: 14, opacity: 0.85, marginBottom: 16 }}>
            {isChunkError
              ? 'Falha ao carregar um módulo. Isso costuma acontecer quando o app foi atualizado. Toque em recarregar.'
              : 'Algo deu errado ao iniciar o aplicativo.'}
          </p>
          <details style={{ fontSize: 11, opacity: 0.6, marginBottom: 16, textAlign: 'left' }}>
            <summary style={{ cursor: 'pointer' }}>Detalhes técnicos</summary>
            <pre style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>{msg}</pre>
          </details>
          <button
            onClick={this.handleReload}
            style={{
              background: '#F59E0B',
              color: '#070B1A',
              border: 'none',
              borderRadius: 8,
              padding: '10px 20px',
              fontWeight: 700,
              fontSize: 14,
              cursor: 'pointer',
            }}
          >
            Recarregar aplicativo
          </button>
        </div>
      </div>
    )
  }
}
